import { loadConfig, svcAuth } from '@pressreader/services';

export async function getConfig() {
    const token = await svcAuth.authorized();
    const { config } = await loadConfig<Record<string, unknown>>(token);
    return config;
}
